import { useContext } from "react"
import { TaskContext } from "./task.context";

export const useTask = () => {
    const context = useContext(TaskContext)
    if (context === undefined){
        throw new Error(`Component is not inside TaskContext scope`);
    }
    return context
}